<div class="box">
    <div class="box-header" *ngIf="title">
        <h3 class="box-title">{{ title }}</h3>
        <p class="pull-right col-gray m-b-0">Last 10 Result</p>
    </div>

    <div class="box-body no-padding std-table-height scroll">
        <table class="mobileTable table table-striped">
            <tr>
                <th> Booth Name </th>
                <th> Customer Name </th>
                <th> Date Time </th>
                <th> Water Dispense </th>
                <th> Total Amount </th>
            </tr>
            <tr *ngFor="let report of withdrawreports">
                <td>{{ report.PumpName }}</td>
                <td>{{ report.CustomerName }}</td>
                <td>{{convertUTCDateToLocalDate(report.DispenseAt) | date:'dd-MM-yyyy hh:mm a'}}</td>
                <td>
                    <span class="label label-drink font-12">{{ report.WaterDispense }}</span>
                </td>
                <td>{{ report.TotalAmount }} BDT</td>
            </tr>
        </table>
    </div>
</div>
